const CartQueryKey = {
  CART: 'CART',
  CART_PAYMENT_CHECK: 'CART_PAYMENT_CHECK',
};

export default CartQueryKey;
